import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FaIcon = ({ icon='mail', color = '#ff7100', isRegIcon = false, iconWidth = 'auto' }) => <FontAwesomeIcon style={{ margin: '0 .5rem', width: iconWidth }} color={color} icon={`${isRegIcon ? 'fa-regular ' : ''}fa-${icon}`} />;

export default FaIcon;